module.exports = __webpack_public_path__ + "img/dd-logo-lincoln-w.ec6579ae.png";